import {AttachmentUploadUrlApiDto} from "../../api/model/rest";

export default class AttachmentUploadUrl {

	constructor(public readonly id: string, public readonly uploadUrl: string) {}

	public static fromJson(json: AttachmentUploadUrlApiDto): AttachmentUploadUrl {
		return new AttachmentUploadUrl(json.id, json.uploadUrl);
	}
}